import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	chatPrompt: {
		id: 'rovo-reintroduction-modal.chat-prompt',
		defaultMessage: 'Tell me how to improve my workflow with Rovo',
		description:
			'Message automatically sent as the first user message in Rovo chat when the primary call to action is clicked.',
	},
});
